module.exports = __webpack_public_path__ + "static/media/smartphones_icon.894a4875.png";